import { Form,FormGroup,Input, Label, Button } from 'reactstrap'
import { useOnChangeHandler } from '../../global/utils/hooks/useOnChangeHandler';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

export default function Range({onOffCanvas}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [priceFrom, setPriceFrom, onHandlerChangePriceFrom] = useOnChangeHandler(searchParams.get('price_from') || '');
  const [priceTo, setPriceTo, onHandlerChangePriceTo] = useOnChangeHandler(searchParams.get('price_to') || '');

  const onClickFilterPrice = () => {
    if(priceFrom){
      searchParams.set('price_from', priceFrom.toString());
    } else {
      searchParams.delete('price_from');
    }
    if(priceTo){
      searchParams.set('price_to', priceTo.toString());
    } else {
      searchParams.delete('price_to');
    }
    searchParams.delete('page');
    setSearchParams(searchParams);
    onOffCanvas(false);
  }

  useEffect(() => {
    setPriceFrom(searchParams.get('price_from') || '')
    setPriceTo(searchParams.get('price_to') || '')
    },[searchParams])
    
  return (
    <div className={`bg-white p-4 lgtBackground mb-3`}>
      <div className={`fw-bold mb-3`}>Price</div>
      <Form>
        <FormGroup floating>
          <Input  bsSize="sm"
                  name='min' 
                  value={priceFrom}
                  placeholder='Min Price' 
                  onChange={onHandlerChangePriceFrom}/>
          <Label>
            Min Price
          </Label>
        </FormGroup>
        <FormGroup floating>
          <Input name='max'
                 placeholder='Max Price' 
                 bsSize="sm" 
                 value={priceTo}
                 onChange={onHandlerChangePriceTo}/>
          <Label>
            Max Price
          </Label>
        </FormGroup>
        <div className='d-grid gap-2 col-6 mx-auto'>
          <Button onClick={onClickFilterPrice}>
            Apply
          </Button>
        </div>
      </Form>
    </div>
  )
}
